export default function(nga, admin, Api) {
    var entity = admin.getEntity('product')
        .label('products');

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('name').label('NAME').isDetailLink(true),
            nga.field('abbr').label('ABBR'),
            nga.field('price','number').label('PRICE_MONTH')
                .format("0,000.00"),
            nga.field('price_annual','number').label('ENROLLMENT')
                .format("0,000.00"),
            nga.field('promotional', 'boolean').label('PRICE_ANNUAL'),
            nga.field('type').label('TYPE'),
            nga.field('licencesType', 'reference_many')
                .label('Licences Type')
                .targetEntity(nga.entity('licencetype').url('licencetypes'))
                .targetField(nga.field('name'))
                .singleApiCall(ids => ({'id': ids })),

            nga.field('units').label('UNITS')
        ])
        .sortDir('asc')
        .url('products')
        .entryCssClasses(function(entry) {
            return (entry.promotional) ? 'warning' : '';
        });

    entity.creationView().fields([
        nga.field('name').label('NAME'),
        nga.field('description', 'text').label('DESCRIPTION'),
        nga.field('image', 'file').label('IMAGE')
            .uploadInformation({ 'url': Api.Path+'product/upload', 'apifilename': 'file'}),
        nga.field('abbr').label('ABBR'),
        nga.field('price','float').label('PRICE_MONTH').format("0,000.00"),
        nga.field('price_annual','float').label('PRICE_ANNUAL')
            .format("0,000.00"),
        nga.field('promotional', 'boolean').label('PROMOTIONAL')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'),
        nga.field('type', 'choice').label('TYPE')
            .choices([
                {label: 'LICENCE', value: 'licence'},
                {label: 'SUBSCRIPTION', value: 'subscription'},
                {label: 'GAME', value: 'game'}
            ]),
        nga.field('licences_type', 'reference_many')
            .label('Licences Type')
            .targetEntity(nga.entity('licencetype').url('licencetypes'))
            .targetField(nga.field('name')),
        nga.field('gamesvr', 'reference_many')
            .label('GAMES')
            .targetEntity(nga.entity('gamevr').url('gamevrs'))
            .targetField(nga.field('name')),
        nga.field('units').label('UNITS'),
        nga.field('codes', 'embedded_list').label('CODES') // Define a 1-N relationship with the (embedded) comment entity
            .targetFields([ // which comment fields to display in the datagrid / form
                nga.field('code').label('CODE'),
                nga.field('limit', 'date')
                    .label('LIMIT').format('dd-MM-yyyy').map(ParseDate)
            ])


    ]).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function(error, form, progression, notification, $filter) {

        $('.form-field').each(function(){
            $(this).removeClass('has-error').find('.help-block.error').remove();
        });

        error.data.fields.forEach(function(error, index){
            let input = $('[name='+error.property_path+']');

            if(error.property_path == 'codes'){
                input = $('#row-codes').find('.row');
            }

            $('<span class="help-block error">'+error.message+'</span>').insertAfter(input);
            input.closest('.form-field').addClass('has-error');
        });

        progression.done();

        //notification.log($filter('translate')(`INVALID_DETAILS_IN_FORM`), { addnCls: 'humane-flatty-error' });

        return true;
    }]);

    entity.editionView().fields(
        entity.creationView().fields()
    ).onSubmitError(entity.creationView().onSubmitError());

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/product/config.js
 **/